<template>
  <div class="permissions">
    <Permission v-for="(permission, index) in permissions" :key="index" :permission="permission"></Permission>
  </div>
</template>

<script>
  import Permission from './Permission.vue';

  export default {
    name: 'Permissions',
    components: {
      Permission,
    },
    props: {
      permissions: {
        type: Array,
      },
    },
  }
</script>

<style scoped lang="scss">
  .permissions {
    display:flex;
    align-items: center;
    min-height: 1.5em;
  }
</style>
